import { useParams } from "react-router-dom";
import { getLocalStorageItem } from "../utils";
import { ApiService, ApiService2 } from "./Axios";

export const getHeaders = (requireAuth = true) => {
  const headers = {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  };

  if (requireAuth) {
    const token = getLocalStorageItem("token");
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  return headers;
};

export const Get = (url) =>
  ApiService.get(url, { headers: getHeaders() });

export const BankGet = (url) =>
  ApiService2.get(url, { headers: getHeaders() });

export const Post = (url, data, auth) =>
  ApiService.post(url, data, { headers: getHeaders(auth) });

export const Patch = (url, data) =>
  ApiService.patch(url, data, { headers: getHeaders() });

export const Put = (url, data) =>
  ApiService.put(url, data, { headers: getHeaders() });

export const Delete = (url) =>
  ApiService.delete(url, { headers: getHeaders() });

export const getAPIUrl = (url, params = "") => {
  return url + `${params}`;
};

export const FormDataPost = (url, data) => {
  return ApiService.post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const FormDataPatch = (url, data) => {
  return ApiService.patch(url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getErrors = (error) => {
  const errorData = error.response?.data?.error || error.response?.data?.errors;
  if (!errorData) return { general: "Something went wrong" };
  const errors = {};
  Object.keys(errorData).forEach((key) => {
    errors[key] = errorData[key];
  });
  return errors;
};